/**
 * Returns a function, that, when invoked, will only be triggered at most once during
 * a given window of time.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Time window (in milliseconds).
 * @returns {Function}
 */
function throttle(fn, wait = 300) {
    let throttleTimeoutId = -1;
    let tick = false;
  
    return () => {
      clearTimeout(throttleTimeoutId);
      throttleTimeoutId = setTimeout(fn, wait);
  
      if (!tick) {
        fn.call();
        tick = true;
        setTimeout(() => {
          tick = false;
        }, wait);
      }
    };
  }
  
  if (!customElements.get('sticky-atc')) {
      class StickyAtc extends HTMLElement {
        constructor() {
          super();
          this.section = this.closest('.main-product-section');
          this.mainProductFormID = this.section.querySelector('.buy_buttons form').getAttribute("id");
          this.buyButtons = this.section.querySelector('.buy_buttons form');
          this.imageContainer = this.querySelector('.sticky-atc__image');
          this.variantContainer = this.querySelector('.sticky-atc__details__variant');
          this.variantTitle = this.querySelector('.sticky-atc__detail__variant');
          this.addToCart = this.querySelector('.add-to-cart');
          this.variantTitle?.toggleAttribute('hidden', !this.section.querySelector('.variant-wrapper'));
  
          this.throttledOnScroll = throttle(StickyAtc.handleScroll.bind(this));
          // this.buttonClicked = this.buttonClicked.bind(this);

        // if (this.addToCart) {
        // this.addToCart.addEventListener('click', this.buttonClicked);
        // }
          window.addEventListener('scroll', this.throttledOnScroll);
        }
  
        disconnectedCallback() {
          window.removeEventListener('scroll', this.throttledOnScroll);
        }
  
        /**
         * Determine visibility after scroll.
         */
        static handleScroll() {
          this.classList.toggle(
            'sticky-atc--out',
            this.buyButtons.getBoundingClientRect().bottom > 0
          );
          if(this.buyButtons.getBoundingClientRect().bottom <= 0){
        // Update the main image
        this.imageContainer.src = this.section.querySelector('.product-image-main image-element img').src;

        // Get selected values from checked radio buttons
        const selectedValues = Array.from(
        this.section.querySelectorAll(`input[type="radio"][form="${this.mainProductFormID}"]:checked`)
        )
        .map(radio => radio.value)
        .join('/');

        // Update variant title
        this.variantTitle.innerHTML = selectedValues;
        if(this.addToCart){
        let variantId = this.buyButtons.querySelector('[name="id"]').value;
        if( variantId) {
          this.querySelector('[name="id"]').value = variantId;
        }
        // Update Add to Cart button text
        if(this.addToCart.textContent.trim() != 'Coming soon') {
        this.addToCart.textContent = this.buyButtons.querySelector(' button span').textContent;
        }
        // Enable or disable the Add to Cart button based on whether it's disabled
        if (this.buyButtons.querySelector(' button').disabled) {
        this.addToCart.disabled = true;
        } else {
        this.addToCart.disabled = false;
        }

       }
          }
  
          document.body.classList.toggle(
            'scrolled-to-bottom',
            window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
          );
        }
        buttonClicked(e) {

            e.preventDefault();

            this.addToCart.disabled = true;

            const realButton = this.buyButtons.querySelector('button');
            if (realButton) {
            realButton.click();
            }

            this.addToCart.disabled = false;
        }

      }
  
      customElements.define('sticky-atc', StickyAtc);
  }
  

